/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initPreloaderScreen();
	initSliders();	
	initProgressBar();	
	openSetHelloBarTimer();

});

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 500);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 850);
	initSubmenus();
}

function openSetHelloBarTimer() {
	if ( localStorage.getItem('seen') != (new Date()).getDate()) {
		setTimeout(initHellobar, 3000);
	}else{
	}
}

function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-main').css('display', 'flex');
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
	localStorage.setItem('seen', (new Date()).getDate());
	console.log("local storage set as seen");
	
}

function initProgressBar() {
	//var ProgressBar;
	// progressbar.js@1.0.0 version is used
	// Docs: http://progressbarjs.readthedocs.org/en/1.0.0/
	var progBar = jQuery('#progress-bar-desktop');
	
	if(progBar.length) {
		 
		var bar = new ProgressBar.Line('#progress-bar-desktop', {
		  strokeWidth: 1,
		  easing: 'easeInOut',
		  duration: 1400,
		  color: '#1279cc',
		  trailColor: '#E5E8EC',
		  trailWidth: 1,
		  svgStyle: {width: '100%', height: '100%'},
		  from: {color: '#1279cc'},
		  to: {color: '#1279cc'},
		  step: (state, bar) => {
			bar.path.setAttribute('stroke', state.color);
		  }
		});
		
		bar.animate(1.0);  // Number from 0.0 to 1.0
		// setInterval(function() {
		//   bar.set(0);
		//   bar.animate(1.0);
		// }, 3300);
		
	}
	
		// progressbar.js@1.0.0 version is used
	// Docs: http://progressbarjs.readthedocs.org/en/1.0.0/
	var progBar2 = jQuery('#progress-bar-mobile');
	
	if(progBar2.length) {
		 
		var bar2 = new ProgressBar.Line('#progress-bar-mobile', {
		  strokeWidth: 1,
		  easing: 'easeInOut',
		  duration: 1400,
		  color: '#E5E8EC',
		  trailColor: '#1279cc',
		  trailWidth: 3,
		  svgStyle: {width: '100%', height: '100%'},
		  from: {color: '#E5E8EC'},
		  to: {color: '#1279cc'},
		  step: (state, bar) => {
			bar.path.setAttribute('stroke', state.color);
		  }
		});
		
		bar2.animate(1.0);  // Number from 0.0 to 1.0
		// setInterval(function() {
		//   bar.set(0);
		//   bar.animate(1.0);
		// }, 3300);
		
	}

}





function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}


function initSliders(){	
	/* https://swiperjs.com/get-started/  */

	var fpcarouselinner = jQuery('.fp-carousel-row-inner');
	if(fpcarouselinner.length) {  
	  var mySwiper = new Swiper ('.fp-carousel-row-inner' , {
	    // Optional parameters
	    direction: 'horizontal',
	    loop: true,
	    autoHeight: true,
	    slidesPerView: 1,
		spaceBetween: 10,
	
	    // If we need pagination
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true,
	      type: 'bullets',
	      	      
	    },
	
	    // Navigation arrows
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev',
	    },
	
	    // And if we need scrollbar
	    scrollbar: {
	      el: '.swiper-scrollbar',
	      draggable: true,
	    },
	  })
	}
}	